import React from "react"
import { DEFAULT_INITIAL_LOAD_NUM_POSTS } from "@data/constants"
import { getRecords, queries, request } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import { datoModels } from "@data/static"
import PostArchive from "@components/layouts/blog/PostArchive/PostArchive"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"

const TopTipsPage = ({ posts, options, seo }) => {
  return (
    <Layout options={options}>
      <Seo
        global={seo}
        title="Top tips"
        description="Looking for advice or inspiration for an upcoming party or event?  Click here to browse the tops tips and latest and latest news from House of Party Planning."
      />
      <PostArchive initialPosts={posts.records} totalPosts={posts.count} />
    </Layout>
  )
}

export default TopTipsPage

export async function getStaticProps() {
  const seo = await request({ query: `{ ${queries.seo} }` })
  const posts = await getRecords(datoModels.POST, DEFAULT_INITIAL_LOAD_NUM_POSTS)
  const options = await loadOptionsData()
  return {
    props: { posts, options, seo },
  }
}
